export const clientSelectConfig = {
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 150,
            sorter: true,
        },
        {
            title: "Имя",
            dataIndex: "firstName",
            key: "firstName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Фамилия",
            dataIndex: "lastName",
            key: "lastName",
            sorter: true,
            ellipsis: true,
            render: (lastName) => lastName || "—",
        },
        {
            title: "Отчество",
            dataIndex: "middleName",
            key: "middleName",
            sorter: true,
            ellipsis: true,
            render: (middleName) => middleName || "—",
        },
        {
            title: "Телефон",
            dataIndex: "phone",
            key: "phone",
            sorter: true,
            width: 150,
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: true,
            ellipsis: true,
            render: (email) => email || "—",
        },
        {
            title: "Дата рождения",
            dataIndex: "dateOfBirth",
            key: "dateOfBirth",
            sorter: true,
            width: 130,
            render: (date) => date ? new Date(date).toLocaleDateString("ru-RU") : "—",
        },
        {
            title: "Дата регистрации",
            dataIndex: "registrationDate",
            key: "registrationDate",
            sorter: true,
            width: 150,
            render: (date) => date ? new Date(date).toLocaleDateString("ru-RU") : "—",
        },
    ],
    rowKey: "id",
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} клиентов`,
    },
};
export const tariffSelectConfig = {
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 150,
            sorter: true,
        },
        {
            title: "Название",
            dataIndex: "name",
            key: "name",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Тип",
            dataIndex: "type",
            key: "type",
            sorter: true,
            width: 120,
        },
        {
            title: "Цена за кВт⋅ч",
            dataIndex: "pricePerKwh",
            key: "pricePerKwh",
            sorter: true,
            width: 130,
            render: (price) => (price ? `${price}₽` : "—"),
        },
        {
            title: "Разовый сбор",
            dataIndex: "oneTimeServiceFee",
            key: "oneTimeServiceFee",
            sorter: true,
            width: 120,
            render: (fee) => `${fee}₽`,
        },
        {
            title: "Экстренный сбор",
            dataIndex: "emergencyServiceFee",
            key: "emergencyServiceFee",
            sorter: true,
            width: 140,
            render: (fee) => (fee ? `${fee}₽` : "—"),
        },
        {
            title: "Подписка",
            dataIndex: "subscriptionPrice",
            key: "subscriptionPrice",
            sorter: true,
            width: 120,
            render: (price) => (price ? `${price}₽` : "—"),
        },
        {
            title: "Действует с",
            dataIndex: "validFrom",
            key: "validFrom",
            sorter: true,
            width: 120,
            render: (date) => new Date(date).toLocaleDateString("ru-RU"),
        },
        {
            title: "Действует до",
            dataIndex: "validTo",
            key: "validTo",
            sorter: true,
            width: 120,
            render: (date) => date ? new Date(date).toLocaleDateString("ru-RU") : "Бессрочно",
        },
    ],
    rowKey: "id",
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} тарифов`,
    },
};
export const technicianSelectConfig = {
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 150,
            sorter: true,
        },
        {
            title: "Имя",
            dataIndex: "firstName",
            key: "firstName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Фамилия",
            dataIndex: "lastName",
            key: "lastName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Отчество",
            dataIndex: "middleName",
            key: "middleName",
            sorter: true,
            ellipsis: true,
            render: (middleName) => middleName || "—",
        },
        {
            title: "Телефон",
            dataIndex: "phone",
            key: "phone",
            sorter: true,
            width: 150,
            render: (phone) => phone || "—",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: true,
            ellipsis: true,
            render: (email) => email || "—",
        },
    ],
    rowKey: "id",
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} техников`,
    },
};
